module.exports = __webpack_public_path__ + "img/button_text.fdd78f92.svg";